const renameKeys = (obj, prefix, initial = {}) =>
  Object.keys(obj).reduce(
    (acc, key) => ({
      ...acc,
      ...{[`${prefix} ${key}`]: obj[key]},
    }),
    initial
  );

export default renameKeys;
